import { createContext, useCallback, useContext, useMemo, useState, type ReactNode } from 'react'

export type HomeCrtChannelMeta = { ch: string; air: string }

const Ctx = createContext<{
  meta: HomeCrtChannelMeta | null
  setHomeCrtChannel: (m: HomeCrtChannelMeta | null) => void
} | null>(null)

export function HomeCrtChannelProvider({ children }: { children: ReactNode }) {
  const [meta, setMeta] = useState<HomeCrtChannelMeta | null>(null)
  const setHomeCrtChannel = useCallback((m: HomeCrtChannelMeta | null) => {
    setMeta(m)
  }, [])
  const value = useMemo(() => ({ meta, setHomeCrtChannel }), [meta, setHomeCrtChannel])
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>
}

export function useHomeCrtChannel() {
  const c = useContext(Ctx)
  return (
    c ?? {
      meta: null,
      setHomeCrtChannel: () => {},
    }
  )
}
